<template>
<div class="subpage-nav">
  <container>
    <div class="subpage-nav__list">
      <div class="subpage-nav__item" v-for="link in links" :key="link.id" :class="{'active' : isActive}" @click="select">
        <router-link :to="link.to" class="subpage-nav__link" exact>
      <span class="btn-txt">
        {{ link.title }}
      </span>
        </router-link>
      </div>
    </div>
  </container>
</div>
</template>

<script>
import { SET_BLOG_CATEGORY_TITLE, SET_BLOG_CATEGORY_SLUG } from '@/store/mutations.type'
export default {
  name: 'SubpageNav',
  props: {
    links: Array
  },
  data () {
    return {
      isActive: false
    }
  },
  methods: {
    select () {
      this.isActive = true
    },   
  }
}
</script>

<style scoped lang="scss">
@import "../assets/scss/components/subpage-nav";
</style>
